// extracted by mini-css-extract-plugin
export default {"loginForm":"LoginPage_loginForm__hu6xw","wrapper":"LoginPage_wrapper__30++x"};